(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('DashboardManagementController', DashboardManagementController);

    DashboardManagementController.$inject = ['$state', 'Dashboard', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function DashboardManagementController($state, Dashboard, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadPage = loadPage;
        vm.predicates = pagingParams.predicates;
        vm.currentState = "dashboard-management";
        vm.transition = transition;

        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder !== null && retrievedOrder !== "null")
            vm.predicates = JSON.parse(retrievedOrder);

        //Aggiunta per impaginazione
        vm.changePageSize = changePageSize;
        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;

        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc' ));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }

        vm.loadAll = function () {
            Dashboard.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPageChosen,
                sort: sort(),
                query: vm.charToSearch
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.dashboards = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        vm.search = function () {
            pagingParams.page = 1;
            vm.loadAll();
            vm.transition(false);
        };

        //Aggiunta per impaginazione
        function changePageSize() {
            if ((vm.queryCount / vm.itemsPerPageChosen) < pagingParams.page)
                vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            transition();
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition(notify) {
            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
                page: vm.page,
                predicates: vm.predicates,
                sort: sort(),
                search: vm.charToSearch,
                itemsPerPageChosen: vm.itemsPerPageChosen
            }, {notify: notify, location: "replace"});
        }

        vm.loadAll();
    }
})();
